import { useCallback, useState } from 'react';
import { resolveValidity, toPromise } from './validationSupport';

function useSingleValidator(initialValidity, baseValidator) {
    const [validationState, setValidationState] = useState(initialValidity);
    const reset = () => setValidationState(initialValidity);

    const validator = useCallback((input) => {
        const result = resolveValidity(baseValidator, input, initialValidity);
        setValidationState(result);
        return result;
    }, [baseValidator, initialValidity]);

    const isValid = () => toPromise(validationState);
    return { validator, isValid, reset };
}

export default useSingleValidator;
